const reg = /[\w\s]/
export default function (val, num) {
  const len = (val && val.length) || 0
  if (len <= num) return val
  let count = 0
  for (let i = 0; i < len && num >= 1; i++) {
    if (reg.test(val[i])) {
      num += 0.5
    }
    count++
    num--
  }
  if (len <= count) return val
  return val.slice(0, count - 1) + '...'
}
